import {NgxSelectBoxFilter} from "../select-box/ngx-select-box-filter";
import {AfterViewInit, Directive} from "@angular/core";

@Directive({})
export abstract class NgxMultiSelectFilter extends NgxSelectBoxFilter implements AfterViewInit {

}
